"use strict";

require("core-js/modules/es.symbol.js");

require("core-js/modules/es.symbol.description.js");

require("core-js/modules/es.symbol.iterator.js");

require("core-js/modules/es.array.iterator.js");

require("core-js/modules/es.string.iterator.js");

require("core-js/modules/web.dom-collections.iterator.js");

require("core-js/modules/es.array.from.js");

require("core-js/modules/es.function.name.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clipboardFallbackMessage = clipboardFallbackMessage;
exports.closest = closest;
exports.default = void 0;
exports.escapeFormattedValue = escapeFormattedValue;
exports.formatAbstract = formatAbstract;
exports.formatCategoryName = formatCategoryName;
exports.formatDate = formatDate;
exports.id = id;
exports.once = once;
exports.sanitizeURL = sanitizeURL;
exports.showTab = showTab;
exports.toggleCollapse = toggleCollapse;

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.string.match.js");

require("core-js/modules/es.array.concat.js");

require("core-js/modules/es.string.replace.js");

require("core-js/modules/es.array.slice.js");

require("core-js/modules/es.string.trim.js");

require("core-js/modules/es.array.join.js");

require("core-js/modules/es.object.to-string.js");

var _uniqueId2 = _interopRequireDefault(require("lodash/uniqueId"));

var _each2 = _interopRequireDefault(require("lodash/each"));

var _escape2 = _interopRequireDefault(require("lodash/escape"));

var _balancedMatch = _interopRequireDefault(require("balanced-match"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
/**
 * Parse iso date and format it in a simple way
 * @param  {String} isoDate - date in iso format
 * @return {String}         - formatted date
 */

function formatDate(isoDate) {
  var matches = isoDate.match(/(\d{4})-?(\d{2})?-?(\d{2})?/);
  var date = isoDate;

  if (matches.length >= 4) {
    var year = matches[1];
    var month = months[parseInt(matches[2], 10) - 1];
    var day = parseInt(matches[3], 10);
    date = "".concat(month, " ").concat(day, ", ").concat(year);
  }

  if (matches.length >= 3) {
    var _year = matches[1];
    var _month = months[parseInt(matches[2], 10) - 1];
    date = "".concat(_month, " ").concat(_year);
  }

  if (matches.length >= 2) {
    date = matches[1];
  }

  return date;
}

function formatAbstract(abstract) {
  return abstract.replace(/(^|\n)([\s\S]*?)(\n|$)/g, '<p>$2</p>');
}
/**
 * Formats category name
 * @param  {String} name 	- unformatted name
 * @return {String}      	- formatted name
 */


function formatCategoryName(name) {
  name = name.replace(/(?! )[A-Z]/g, ' $&');
  return name.charAt(0).toUpperCase() + name.slice(1);
}
/**
 * Finds the first element that pasess function test by testing the element itself
 * and traversing up
 * @param  {HTMLElement}   el 	- A DOM element from which tracersing begins
 * @param  {Function} fn 		- Function that tests if element is suitable
 * @return {HTMLElement}		- First element that passes the test
 */


function closest(el, fn) {
  return el && (fn(el) ? el : closest(el.parentNode, fn));
}
/**
 * Register a one-time event listener.
 *
 * @param {EventTarget} target
 * @param {String} type
 * @param {Function} listener
 * @returns {Function} deregister
 */


function once(target, type, listener) {
  function deregister() {
    target.removeEventListener(type, handler); // eslint-disable-line no-use-before-define
  }

  function handler() {
    deregister();
    return listener.apply(this, arguments);
  }

  target.addEventListener(type, handler);
  return deregister;
}
/**
 * Uniquely and pernamently identify a DOM element even if it has no id
 * @param  {HTMLElement} target - DOM element to identify
 * @return {String} 			- unique identifier
 */


function id(target) {
  target.id = target.id || (0, _uniqueId2.default)('zotero-element-');
  return target.id;
}

function resetHeight(ev) {
  ev.currentTarget.removeEventListener('transitionend', resetHeight);
  ev.currentTarget.style.height = null;
}

function collapse(element) {
  var sectionHeight = element.scrollHeight;
  var elementTransition = element.style.transition;
  element.style.transition = '';
  element.removeEventListener('transitionend', resetHeight);
  requestAnimationFrame(function () {
    element.style.height = sectionHeight + 'px';
    element.style.transition = elementTransition;
    requestAnimationFrame(function () {
      element.style.height = 0 + 'px';
    });
  });
  element.setAttribute('data-collapsed', 'true');
  element.setAttribute('aria-expanded', false);
}

function uncollapse(element) {
  var sectionHeight = element.scrollHeight;
  element.removeEventListener('transitionend', resetHeight);
  element.addEventListener('transitionend', resetHeight);
  element.style.height = sectionHeight + 'px';
  element.setAttribute('data-collapsed', 'false');
  element.setAttribute('aria-expanded', true);
}
/**
 * Collpases or uncollapses a DOM element
 * @param  {HTMLElement} element 	- DOM element to be (un)collapsed
 */


function toggleCollapse(element, override) {
  if (typeof override !== 'undefined') {
    override ? uncollapse(element) : collapse(element); // eslint-disable-line no-unused-expressions

    return override;
  }

  var isCollapsed = element.getAttribute('data-collapsed') === 'true';
  isCollapsed ? uncollapse(element) : collapse(element); // eslint-disable-line no-unused-expressions

  return isCollapsed;
}

function showTab(targetTabEl) {
  var tablistEl = closest(targetTabEl, function (el) {
    return el.getAttribute('role') === 'tablist';
  });
  var targetTabContainer = targetTabEl.parentElement;
  var tabs = tablistEl.querySelectorAll('li.zotero-tab');
  var tabpanelId = targetTabEl.getAttribute('aria-controls');
  var targetTabPanelEl = document.getElementById(tabpanelId);
  var tabPanelsWrapper = closest(targetTabPanelEl, function (el) {
    return el.classList.contains('zotero-tab-content');
  });
  var tabPanels = tabPanelsWrapper.querySelectorAll('.zotero-tabpanel');
  (0, _each2.default)(tabs, function (tabEl) {
    tabEl.classList.remove('zotero-tab-active');
    tabEl.querySelector('a').setAttribute('aria-selected', false);
  });
  (0, _each2.default)(tabPanels, function (tabPanelEl) {
    tabPanelEl.classList.remove('zotero-tabpanel-open');
    tabPanelEl.setAttribute('aria-expanded', false);
    tabPanelEl.setAttribute('aria-hidden', true);
  });
  targetTabContainer.classList.add('zotero-tab-active');
  targetTabPanelEl.classList.add('zotero-tabpanel-open');
  targetTabPanelEl.setAttribute('aria-expanded', true);
  targetTabPanelEl.setAttribute('aria-hidden', false);
  targetTabEl.setAttribute('aria-selected', true);
}
/**
 * Returns a fallback message for a clipboard
 * @return {String} 	- a fallback message
 */


function clipboardFallbackMessage() {
  var actionMsg = '';

  if (/Mac/i.test(navigator.userAgent)) {
    actionMsg = 'Press ⌘-C to copy';
  } else {
    actionMsg = 'Press Ctrl-C to copy';
  }

  return actionMsg;
}

function sanitizeURL(url) {
  url = url.trim();

  if (/^(https?|ftp):\/\//i.test(url)) {
    return url;
  } else {
    return "http://".concat(url);
  }
}

var mappings = [[['&lt;b&gt;', '&lt;/b&gt;'], ['<b>', '</b>']], [['&lt;i&gt;', '&lt;/i&gt;'], ['<i>', '</i>']], [['&lt;sc&gt;', '&lt;/sc&gt;'], ['<span class="small-caps">', '</span>']], [['&lt;sub&gt;', '&lt;/sub&gt;'], ['<sub>', '</sub>']], [['&lt;sup&gt;', '&lt;/sup&gt;'], ['<sup>', '</sup>']]];

function recursiveBalancedMatch(mapping, value) {
  var matches = _balancedMatch.default.apply(void 0, _toConsumableArray(mapping[0]).concat([value]));

  if (matches) {
    return [recursiveBalancedMatch(mapping, matches.pre), mapping[1][0], recursiveBalancedMatch(mapping, matches.body), mapping[1][1], recursiveBalancedMatch(mapping, matches.post)].join('');
  } else {
    return value;
  }
}

function escapeFormattedValue(value) {
  var escaped = (0, _escape2.default)(value);
  return mappings.reduce(function (value, mapping) {
    return recursiveBalancedMatch(mapping, value);
  }, escaped);
}

var _default = {
  formatDate: formatDate,
  formatAbstract: formatAbstract,
  formatCategoryName: formatCategoryName,
  closest: closest,
  once: once,
  id: id,
  toggleCollapse: toggleCollapse,
  showTab: showTab,
  clipboardFallbackMessage: clipboardFallbackMessage,
  sanitizeURL: sanitizeURL,
  escapeFormattedValue: escapeFormattedValue
};
exports.default = _default;